import { createTheme } from '@mui/material/styles';
import { theme } from '../../styles/theme';

/**
 * The base theme with one token changed: `palette.background.paper`.
 *
 * The app-wide value is `colors.sand` (#f9f4e6) — a warm cream that belongs to
 * the chat surface, where `.main-content` paints the same sand behind it. The
 * advisory routes deliberately override that page surface to white
 * (`visualLanguage.ts`'s `pageSurface`), but every FLOATING surface — the
 * header's language menu, `EngagementRow`'s row menu, its delete dialog — kept
 * reading `background.paper` and so kept landing cream on top of a white page.
 *
 * Overridden here rather than in `theme.ts` because chat still wants sand:
 * changing the global token would repaint every chat menu and dialog too.
 *
 * The new value is read from `palette.background.default` rather than written
 * as a white literal — that is the same token `pageSurface` paints the advisory
 * page with, so the floating surface cannot drift away from the page under it,
 * and `visualLanguage.test.ts`'s token audit stays satisfied (no advisory
 * source may carry a raw hex).
 *
 * Applied via a nested `ThemeProvider` around the advisory routes (`App.tsx`'s
 * `AdvisoryLayout`) rather than by CSS. That placement is deliberate and load-
 * bearing: MUI reads the theme from React context, which portals inherit, so a
 * nested provider reaches menus and dialogs that render into `document.body`
 * and are therefore outside the route's DOM subtree entirely. It also has to
 * wrap `StandardLayout`, not just the page, because the language switcher
 * lives in the shared `Header` — a sibling of the page content, not a
 * descendant of it.
 */
export const advisoryTheme = createTheme(theme, {
  palette: {
    background: {
      paper: theme.palette.background.default,
    },
  },
});
